import * as z from 'zod';

import { ENTITY_TYPE } from 'src/features/entity/types';

const emailSchema = z
    .string()
    .transform((value) => {
        const trimmed = value.trim();
        return trimmed === '' ? undefined : trimmed;
    })
    .pipe(z.email().optional());

export type EntityFormSchemaValues = z.infer<typeof entityFormSchema>;

export const entityFormSchema = z.object({
    name: z.string(),
    type: z.enum(ENTITY_TYPE).nullish(),
    phone: z.string().nullish(),
    email: emailSchema.optional().nullable(),
    description: z.string().nullish(),
    identifier: z.string().nullish(),
    parent: z.string().optional().nullable(),
});

export type EntityFormFieldSchemaValues = z.infer<typeof entityFormFieldSchema>;

export const entityFormFieldSchema = z.object({
    owner: z.string().nullish(),
    entity: entityFormSchema.nullish(),
});
